module.exports = __webpack_public_path__ + "img/MB-001_back.131c6757.jpg";